<template>
  <v-card class="ma-4">
    <v-col>
      <UploadForm
        ref="uploadForm"
        :title="$t('components.fields.avatar.avatar')"
        :upload-url="'/api/v1/avatar/'"
        :extensions="['gif', 'jpg', 'jpeg', 'png']"
        :name="'image'"
        :multiple="false"
        :additional-data="{ no_resize: true }"
      >
        <template #preview>
          <p>{{ $t('components.fields.avatar.currentAvatar') }}</p>
          <figure v-if="props.currentAvatar" class="image is-48x48">
            <img
              :src="avatarUrl(props.currentAvatar)"
              alt="Placeholder image"
            />
          </figure>
        </template>
        <template #file-restrictions>
          <v-list color="primary" class="w-full">
            <v-list-item class="text-body-2 text-disabled">{{
              $t('components.fields.avatar.resolutionLimit')
            }}</v-list-item>
            <v-list-item class="text-body-2 text-disabled">
              {{ $t('components.fields.avatar.fileSizeLimit') }}
            </v-list-item>
          </v-list>
        </template>
      </UploadForm>
    </v-col>
  </v-card>
</template>

<script setup lang="ts">
import { computed, type Ref, ref } from 'vue'

import { apiClient } from '@/api/ApiClient'
import UploadForm from '@/components/common/UploadForm.vue'

type AvatarUploadFormProps = {
  currentAvatar: string | null
}

const emit = defineEmits(['remove'])
const props = defineProps<AvatarUploadFormProps>()

const uploadForm: Ref<typeof UploadForm> = ref(null)

function avatarUrl(id: string) {
  if (id !== '' && id !== null) {
    return apiClient.getAttachmentUrl(id)
  } else {
    return '/img/empty_avatar.png'
  }
}

function remove() {
  // remvove avatar
  emit('remove')
}

const avatar = computed(() => {
  if (uploadForm.value !== null) {
    const files = uploadForm.value.uploadedFiles
    if (files.length > 0) {
      return files[0].response.id
    } else {
      return null
    }
  } else {
    return null
  }
})

defineExpose({
  avatar,
})
</script>
